/** Балл в списке тестов: API может отдать decimal как число или строку. */
export function formatTestListScore(raw: unknown): string {
  if (raw == null || raw === '') return '—'
  const n = typeof raw === 'number' ? raw : Number(raw)
  if (!Number.isFinite(n)) return '—'
  return String(Math.round(n))
}
